import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Util from '../utils/utils';
import { Row, Col } from 'reactstrap';
import {BINDING_STATUS_MAP} from "./Authentication/Authentication";
import {NO_PARAM_REDIRECT_APPID} from "../constant";

const ResultScreen = () => {
  const [step, setStep] = useState(1)
  const [phone, setPhone] = useState('')
  const [returnMessage, setReturnMessage] = useState('')
  const [showMessage, setShowMessage] = useState(false)
  const [secsBack, setSecsBack] = useState(5)
  const [redirectUrl, setRedirectUrl] = useState('')
  const [iconUrl, setIconUrl] = useState("")
  const [merchantName, setMerchantName] = useState("")
  const interval = useRef(false)
  const location = useLocation();

  useEffect(() => {
    document.title = 'Liên kết Zalopay';
    const params = location.state;
    if (!params) return;
    let returnCode = params.return_code
    let returnMessage = params.return_message
    let bindingInfo = params.binding_info
    const isV2 = params.isV2;
    let status = params.status

    if(isV2) {
      handleBindingV2(bindingInfo, status);
    }
    else {
      const mcInfo = Util.getMerchantInfo(bindingInfo);
      setIconUrl(mcInfo.app_icon_url)
      setMerchantName(mcInfo.merchant_name)
      if (bindingInfo.app_id)
        setRedirectUrl(bindingInfo.redirect_url + '?app_id=' + bindingInfo.app_id + "&binding_id=" + bindingInfo.binding_token + "&status=" + status)
    }
    if (returnCode) {
      switch (parseInt(returnCode)) {
        case 1:
          if (status !== 1) {
            setReturnMessage(returnMessage)
          }
          break;
        case -7035:
          setReturnMessage("Vượt quá số lần nhập mã OTP")
          break;
        case -7208:
          setReturnMessage("Vượt quá số lần gửi lại mã OTP")
          break;
        case -7001:
          setReturnMessage("Có lỗi xảy ra. Vui lòng thử lại!")
          break;
        case -7025:
          setReturnMessage("Hết hạn liên kết. Vui lòng thử lại!")
          break;
        default:
          setReturnMessage(returnMessage)
          break;
      }
      setShowMessage(true)
    } else {
      setShowMessage(false)
    }

    setStep(params.step)
    interval.current = setInterval(() => {
      if (secsBack > 0) {
        setSecsBack(secsBack => secsBack - 1)
      }
    }, 1000);

  }, []);

  useEffect(() => {
    if (secsBack === 0) {
      clearInterval(interval.current);
      turnBackToMerchant();
    }
  }, [secsBack]);

  const handleBindingV2 = (bindingInfo, status) => {
    if (!bindingInfo.id) return;
    setMerchantName(bindingInfo.merchant.name);
    setIconUrl(bindingInfo.merchant.logo)
    if(bindingInfo?.merchant?.link?.redirect_url) {
      let rURL = new URL(bindingInfo?.merchant?.link?.redirect_url);
      if (!NO_PARAM_REDIRECT_APPID.find(item => item === bindingInfo?.merchant?.app_id)) {
        rURL.searchParams.append("app_id", bindingInfo?.merchant?.app_id);
        rURL.searchParams.append("binding_id", bindingInfo?.id);
        rURL.searchParams.append("status", BINDING_STATUS_MAP[status]);
      }
      setRedirectUrl(rURL);
    }
  }

  const turnBackToMerchant = () => {
    clearInterval(interval.current)
    if (redirectUrl !== "")
      window.location.href = redirectUrl;
  }

  return (
    <div>
      <Row>
        <Col md={12}>
          {step === 1 ? (
            <div className="status-page">
              <div className="top-body">
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <h1>Liên kết<br />Zalopay & {merchantName}</h1>
                      <div className="logos">
                        <a href="#" className="logozp"><img
                          src="/img/zlp-logo-new.svg"
                          alt="logo zalopay" /></a>
                        <a href="#" className="logogg"><img
                          src={iconUrl} alt="logo mc" /></a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="top-bg">
                  <img src="/img/bg-blue.svg" alt="bg-blue" />
                </div>
              </div>
              <div className="bottom-body">
                <div className="container">
                  <div className="row">
                    <div className="col-12 status-wrap">
                      <div className="icon-status">
                        <img src="/img/icon-success.svg" alt="success" />
                      </div>
                      <div className="status-text">
                        <p className="big-text success">Xác thực thành
                            công</p>
                        <p className="small-text">Tài khoản Zalopay của Quý
                            Khách <span>{phone}</span> đã xác thực liên kết thành công với {merchantName}</p>
                      </div>
                      <div className="redirect" style={{ cursor: 'pointer' }} onClick={turnBackToMerchant}>
                        <p>Quay về {merchantName} trong (<span>{secsBack}s</span>)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
              <div className="status-page">
                <div className="top-body">
                  {merchantName && merchantName !== '' &&
                    <div className="container">
                      <div className="row">
                        <div className="col-12">
                          <h1>Liên kết<br />Zalopay & {merchantName}</h1>
                          <div className="logos">
                            <a href="#" className="logozp"><img
                              src="/img/zlp-logo-new.svg"
                              alt="logo zalopay" /></a>
                            <a href="#" className="logogg"><img
                              src={iconUrl} alt="logo" /></a>
                          </div>
                        </div>
                      </div>
                    </div>}
                  <div className="top-bg">
                    <img src="/img/bg-blue.svg" alt="bg-blue" />
                  </div>
                </div>
                <div className="bottom-body">
                  <div className="container">
                    <div className="row">
                      <div className="col-12 status-wrap">
                        <div className="icon-status">
                          <img src="/img/icon-fail.svg" alt="success" />
                        </div>
                        <div className="status-text">
                          <p className="big-text fail">Xác thực thất
                          bại</p>
                          <p style={{ paddingBottom: "15px", display: showMessage }}>
                            {returnMessage}</p>
                          <p className="small-text">Bạn đã xác thực tài
                          khoản không thành công. Vui lòng thử lại</p>
                        </div>
                        <div className="redirect" style={{ cursor: 'pointer' }} onClick={turnBackToMerchant}>
                          <p>Quay về trong (<span>{secsBack}s</span>)</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

        </Col>
      </Row>
      <Row>
        <Col md={12} id={"zpfooter"}>
          <div className="container">
            <div className="row">
              <div className="appstores col-md-6">
                <a href="https://itunes.apple.com/vn/app/zalopay-thanh-to%C3%A1n-trong-2s/id1112407590?l=vi&mt=8" className="applestore">
                  <img src="/img/logo-apple.svg" alt="apple" />
                  <div className="store-text">
                    <p className="small-text">Tải ứng dụng từ</p>
                    <p className="store-name">App Store</p>
                  </div>
                </a>

                <a href="https://play.google.com/store/apps/details?id=vn.com.vng.zalopay&hl=en" className="playstore">
                  <img src="/img/logo_play.svg" alt="apple" />
                  <div className="store-text">
                    <p className="small-text">Tải ứng dụng từ</p>
                    <p className="store-name">Google Play</p>
                  </div>
                </a>

              </div>

              <div className="support-secure col-md-6">

                <h2>Hỗ trợ khách hàng</h2>
                <div className="support-list">
                  <a href="tel:1900545436" className="phone">
                    <div className="phone-icon"><img
                      src="/img/icon-phone.svg" alt="phone" /></div>
                    <div className="phone-number">
                      <p className="number">1900 54 54 36</p>
                      <p className="desc">(cước phí 1,000đ/phút)</p>
                    </div>
                  </a>
                  <a href="mailto:hotro@zalopay.vn" className="mail">
                    <div className="mail-icon"><img
                      src="/img/icon-mail.svg" alt="mail" /></div>
                    <div className="mail-text">
                      <p className="number">hotro@zalopay.vn</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ResultScreen;
